import { ArrowUpIcon } from 'lucide-react'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { FooterContent } from '~/App/components/FooterContent'
import { Layout, LayoutContent, LayoutFooter } from '~/App/components/Layout'
import useApp from '~/App/slice/useApp'
import { Button } from '~/DesignSystem/components/button'
import { Messages } from '~/DesignSystem/components/messages'
import { Textarea } from '~/DesignSystem/components/textarea'
import { cn } from '~/DesignSystem/lib/utils'

import { ThreadsScroll } from '../chat/components/ThreadsScroll'
import { PreviewMessage } from './components/PreviewMessage'

export function PreviewPage() {
  const { widget } = useApp()
  const intl = useIntl()

  const message = useMemo(() => widget?.attributes.opening?.message || undefined, [widget])

  return (
    <Layout>
      <LayoutContent className="p-0">
        <ThreadsScroll>
          <Messages>
            <PreviewMessage message={message} />
          </Messages>
        </ThreadsScroll>
      </LayoutContent>
      <LayoutFooter
        className={cn(
          'flex flex-col gap-2',
          widget?.attributes.mode === 'PLAYGROUND' && 'border-t-0',
        )}
      >
        <form onSubmit={e => e.preventDefault()}>
          <div className="relative">
            <Textarea
              value=""
              className="resize-none h-28 pr-12"
              placeholder={intl.formatMessage({ id: 'chat.message.placeholder' })}
            />
            <Button type="submit" className="absolute right-4 bottom-4 rounded-full" size="icon-lg">
              <ArrowUpIcon />
            </Button>
          </div>
        </form>
        {widget?.attributes.mode !== 'PLAYGROUND' && <FooterContent />}
      </LayoutFooter>
    </Layout>
  )
}
